import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RiskyPregnancyDto } from '@app/data/dtos/ptrab/certificates/certificates.dto';
import { mapRiskyPregnancyCertificateData } from '@app/data/mappers/ptrab/certificates/certificates.mappers';
import { CertificatesRepository } from '@app/domain/repositories/ptrab/certificates/certificates.repository.contract';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { RiskyPregnancyCertificate } from '@app/entities/models/ptrab/certificates/risky-pregnancy.model';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class CertificatesRepositoryImpl extends MRepository implements CertificatesRepository {
  url = '/ptrab/certificate/risk-during-pregnancy-list';

  constructor() {
    super(`${ENV.API_URL_PTRAB}`);
  }

  getRiskyPregnancyList(): Observable<RiskyPregnancyCertificate[]> {
    return this.get<IDataResponse<RiskyPregnancyDto>>(this.url, {
      context: new HttpContext().set(SECTION_KEY, 'certificates')
    }).pipe(map(mapRiskyPregnancyCertificateData));
  }
}
